import React, { useMemo } from "react";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { CDRInformationModel } from "../../forms/custom-cdr/schema";
import { formatTime } from "../../../utils/utilities";
import { Column } from "../../../utils/models";
import { FULL_DATE_FORMAT } from "../../../utils/constants";

import useProjectDetails from "../../../hooks/useProjectDetails";

interface Props {
    information: CDRInformationModel;
    cdrReportNumber: string;
}

const CDRInformationPDF: React.FC<Props> = ({ cdrReportNumber, information }) => {
    const { projectDetails } = useProjectDetails();

    const data = useMemo(() => {
        if (!projectDetails || !information) {
            return [];
        }

        return [
            {
                label: 'CDR Serial Number:',
                value: cdrReportNumber,
            },
            {
                label: 'Tag:',
                value: information.tagNumber,
            },
            {
                label: 'Identification Information:',
                value: information.identificationInformation,
            },
            {
                label: 'Installation:',
                value: information.installation,
            },
            {
                label: 'System No.:',
                value: information.systemNumber,
            },
            {
                label: 'Functional Location:',
                value: information.functionalLocation,
            },
            {
                label: 'Pressure (Barg):',
                value: information.pressure,
            },
            {
                label: 'Temperature (C):',
                value: information.temperature,
            },
            {
                label: 'Process:',
                value: information.process,
            },
            {
                label: 'P & ID Number:',
                value: information.pidNumber,
            },
            {
                label: 'Module:',
                value: information.module?.value,
            },
            {
                label: 'Location:',
                value: information.location,
            },
            {
                label: 'Picture Description:',
                value: information.pictureDescription,
            },
            {
                label: 'Anomaly Description:',
                value: information.anomalyDescription,
            },
            {
                label: 'Date:',
                value: formatTime(information.dateOfFinding, FULL_DATE_FORMAT),
            },
        ]
    }, [information, cdrReportNumber, projectDetails]);

    return ( 
        <CustomSection
            showMetadata={false}
            sectionTitle="Corrosion Damage Report"
            sectionSubtitle="Information"
            titleStyle={{ paddingLeft: '1rem', justifyContent: 'flex-start', backgroundColor: '#2e4e6a', color: '#FFFFFF', textAlign: 'left' }}
            subtitleStyle={{ paddingLeft: '1rem', justifyContent: 'flex-start', backgroundColor: '#0076b1', color: '#FFFFFF', textAlign: 'left', textTransform: 'capitalize' }}
        >
            <div className="p-1">
                <PDFTablePage data={data} columns={columns} />
            </div>
        </CustomSection>
    );
};

const columns: Column[] = [
    {
        path: 'label',
        label: 'Label',
        style: () => ({ textAlign: 'left', fontWeight: '700', border: 'none' }),
        headerStyle: { textAlign: 'left', display: 'none' },
    },
    {
        path: 'value',
        label: 'Value',
        style: () => ({ textAlign: 'left', border: 'none' }),
        headerStyle: { textAlign: 'left', display: 'none' },
    },
];
 
export default CDRInformationPDF;